import RestController from './../elements/RestController';
// import RestController2 from './../elements/RestController2';

(function (window, document, $) {
    'use strict';

    $(function () {

        const jsCustomSelect = ($this, field) => {
            let numberOfOptions = $this.children('option').length;

            if ($this.hasClass('select-hidden')) {
                $this.closest('.select').find('.select-styled').remove();
                $this.closest('.select').find('.select-options').remove();
            } else {
                $this.addClass('select-hidden');
                $this.wrap('<div class="select"></div>');
            }

            $this.after('<div class="select-styled"></div>');

            let $styledSelect = $this.next('div.select-styled');

            let selected = $this.children('option').eq(1);

            if ($this.hasClass('two-line-select') && selected.attr("data-name") !== undefined) {
                const selectedText = '<span class="blue-text-option">' + selected.attr("data-name") + '</span><span>' + selected.attr("data-build") + selected.attr("data-to") + '</span>';
                $(selectedText).appendTo($styledSelect);
            } else {
                let selected = $this.children('option').eq(1);
                $styledSelect.text(selected.text());
            }

            let $list = $('<ul />', {
                'class': 'select-options'
            }).insertAfter($styledSelect);



            for (let i = 1; i < numberOfOptions; i++) {
                const $option = $this.children('option').eq(i);
                const dataBuildFrom = $option.attr("data-build");
                const dataBuildTo = $option.attr("data-to");
                const dataName = $option.attr("data-name");
                const value = $option.val();

                if ($this.hasClass('two-line-select') && dataName !== undefined) {
                    $('<li rel="' + value + '">' + '<span class="blue-text-option">' + dataName + '</span>' + dataBuildFrom + dataBuildTo + '</li>').appendTo($list);
                } else {
                    $('<li />', {
                        text: $option.text(),
                        rel: $option.val()
                    }).appendTo($list);
                }
            }

            let $listItems = $list.children('li');

            $styledSelect.on('click', function (e) {
                e.stopPropagation();
                $('div.select-styled.active').not(this).each(function () {
                    $(this).removeClass('active').next('ul.select-options').hide();
                });
                $(this).toggleClass('active').next('ul.select-options').toggle();
            });

            $listItems.on('click', function (e) {
                e.stopPropagation();
                $styledSelect.html($(this).html())
                $styledSelect.removeClass('active');
                $this.val($(this).attr('rel')).change();
                $list.hide();
            });

            $(document).on('click', function (e) {
                $styledSelect.removeClass('active');
                $list.hide();
            });

            if (field === 'type') {
                $('#ic-type').parents('.select').find('.select-options').children('li:first').css({'cursor': 'not-allowed', 'opacity': '0.3'})
            }
        }



        $('.js-select').each(function () {
            jsCustomSelect($(this));
        });

        const rest = new RestController(vehicletree.resturl);
        const form = '.interval-calculcator-form';

        $(form).each(function (i, obj) {
            getRestData($(obj).find('.ic-generation'));
        })

        $(form).on('change', 'select.ic-generation', function (e) {
            getRestData($(this));
        });

        function getRestData($this) {
            let $selectType = $this.closest('form').find('.ic-type'),
                generationId = $this.children('option:selected').data('generation-id'),
                brandId = $this.closest('form').find('.ic-brand').data('brand-id');

            // for on ready
            if (generationId === null || generationId === undefined) {
                generationId = $this.children('option').eq(1).data('generation-id');
            }

            let types = rest.types(brandId, generationId);
            $selectType.after('<div class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>');

            let $selectStyle = $this.closest('form').find('.select-styled');
            $selectStyle.css('pointer-events', 'none');
            types.then(response => {
                if (response.types) {
                    $selectType.html('');
                    $.each(response.types.sort(sortByName), function (index, type) {
                        let optionText = type.name;

                        optionText += type.kw ? ` / ${type.ps} PS (${type.kw} kW)` : '';
                        optionText += type.displacement ? `, ${type.displacement} ccm` : '';

                        $selectType.append($('<option></option>')
                            .attr('value', type.unique_vid).text(optionText));
                    });
                    $selectType.prepend($('<option></option>')
                        .attr('value', -1).text('Bitte Motorisierung auswählen'))
                    $selectType.prepend($('<option></option>')
                        .attr('value', -1).text('Bitte Motorisierung auswählen'))
                    $('.lds-ellipsis').remove();
                    $selectStyle.css('pointer-events', 'auto');
                    jsCustomSelect($selectType, 'type');
                }
            });
        }

        function sortByName( a, b )
        {
            if ( a.name < b.name ) {
                return -1;
            }
            if ( a.name > b.name ) {
                return 1;
            }
            return 0;
        }
    });
}(window, document, jQuery));
